import { render, staticRenderFns } from "./EndObservationModal.vue?vue&type=template&id=eea36f76"
import script from "./EndObservationModal.vue?vue&type=script&lang=ts"
export * from "./EndObservationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports